import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FiShoppingBag, FiSearch, FiMenu, FiX } from "react-icons/fi";
import "./Navbar.css";

const DEFAULT_LINKS = [
    { label: "Shop", path: "/shop" },
    { label: "Canvas", path: "/canvas" },
    { label: "News", path: "/news" },
    { label: "Bookstores", path: "/local-bookstores" },
    { label: "About", path: "/about" },
    { label: "Contact", path: "/contact" },
];

export default function Navbar({ generalConfig }) {
    const { totalItems, setIsOpen } = useCart();
    const [search, setSearch] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [navLinks, setNavLinks] = useState(DEFAULT_LINKS);
    const navigate = useNavigate();

    useEffect(() => {
        async function loadNav() {
            try {
                const snap = await getDoc(doc(db, "siteConfig", "navigation"));
                if (snap.exists() && snap.data().links) {
                    setNavLinks(snap.data().links);
                }
            } catch (err) {
                console.error("Error loading nav:", err);
            }
        }
        loadNav();
    }, []);

    const siteName = generalConfig?.siteName || "LB Books";
    const siteLogo = generalConfig?.siteLogo;

    function handleSearch(e) {
        e.preventDefault();
        if (search.trim()) {
            navigate(`/shop?q=${encodeURIComponent(search.trim())}`);
            setShowSearch(false);
            setSearch("");
        }
    }

    return (
        <header className="navbar">
            <div className="navbar-inner container">
                <Link to="/" className="navbar-logo">
                    {siteLogo ? (
                        <img src={siteLogo} alt={siteName} />
                    ) : (
                        <span style={{ fontSize: "1.5rem", fontWeight: 800, color: "var(--green-primary)", letterSpacing: "-0.5px" }}>
                            {siteName}
                        </span>
                    )}
                </Link>

                <nav className={`navbar-links ${menuOpen ? "open" : ""}`}>
                    {navLinks.filter(l => !(l.path === "/canvas" && generalConfig?.canvasEnabled === false)).map((link, idx) => (
                        <Link 
                            key={idx} 
                            to={link.path} 
                            onClick={() => setMenuOpen(false)}
                            target={link.path.startsWith("http") ? "_blank" : undefined}
                            rel={link.path.startsWith("http") ? "noopener noreferrer" : undefined}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <div className="navbar-actions">
                    <button className="icon-btn" onClick={() => setShowSearch(s => !s)} aria-label="Search">
                        <FiSearch size={20} />
                    </button>
                    <button className="icon-btn cart-btn" onClick={() => setIsOpen(true)} aria-label="Cart">
                        <FiShoppingBag size={20} />
                        {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
                    </button>
                    <button className="icon-btn mobile-menu-btn" onClick={() => setMenuOpen(m => !m)} aria-label="Menu">
                        {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
                    </button>
                </div>
            </div>

            {showSearch && (
                <div className="search-bar container">
                    <form onSubmit={handleSearch}>
                        <input
                            autoFocus
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search books..."
                        />
                        <button type="submit" className="btn-primary">Search</button>
                        <button type="button" className="btn-outline" onClick={() => setShowSearch(false)}>Cancel</button>
                    </form>
                </div>
            )}
        </header>
    );
}